import PropTypes from 'prop-types'
import React from 'react'
import { MdEmail, MdPrint } from 'react-icons/md'

import { FloatingActionButton } from '../../../shared/NarusMaterial'

import ShareModal from './Modal'

export default class ShareFAB extends React.Component {
  constructor (props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
    this.state = {
      open: false,
      communicationMedium: null
    }
  }

  handleClick = type => {
    this.setState({
      open: true,
      communicationMedium: type
    })
  }

  handleClose () {
    this.setState({ open: false })
  }

  render () {
    const { open, communicationMedium } = this.state
    const { reportMeta } = this.props
    const renderModal = () => {
      if (open) {
        return (
          <ShareModal
            onClose={this.handleClose}
            communicationMedium={communicationMedium}
            reportMeta={reportMeta}
          />
        )
      }
      return null
    }

    return (
      <div className='row between-xs'>
        {renderModal()}
        <FloatingActionButton>
          <div style={{ display: 'flex', gap: '10px', flexDirection: 'row-reverse' }}>
            <FloatingActionButton onClick={() => this.handleClick('email')}>
              <MdEmail />
            </FloatingActionButton>

            <FloatingActionButton onClick={() => this.handleClick('fax')}>
              <MdPrint />
            </FloatingActionButton>
          </div>
        </FloatingActionButton>
      </div>
    )
  }
}

ShareFAB.propTypes = {
  reportMeta: PropTypes.instanceOf(Object).isRequired
}
